const namespaced = true

const state = {
  acceptablesSetting: {}
}

const mutations = {
  setOverrideAcceptablesSetting (state, data) {
    state.acceptablesSetting = data.acceptablesSetting
  }
}

const getters = {
  getOverrideAcceptablesSetting: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideAcceptablesSetting.js